export interface RxTermsResult {
    name: string;
    strengthsAndForms: string[];
}

const API_BASE = "https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search";

export async function searchMedications(query: string, maxList = 20): Promise<RxTermsResult[]> {
    if (!query || query.length < 2) {
        return [];
    }

    const url = `${API_BASE}?terms=${encodeURIComponent(query)}&maxList=${maxList}&ef=STRENGTHS_AND_FORMS`;
    const res = await fetch(url);
    if (!res.ok) {
        return [];
    }

    const data = await res.json();
    // Response format: [count, [names], { STRENGTHS_AND_FORMS: [[doses], ...] }, [[display]]]
    const [, names, extras] = data as [number, string[], { STRENGTHS_AND_FORMS: string[][] }];

    if (!names || names.length === 0) {
        return [];
    }

    return names.map((name, i) => ({
        name,
        strengthsAndForms: extras?.STRENGTHS_AND_FORMS?.[i] ?? []
    }));
}
